export const WIDGET_ICON_BACKGROUND_TYPE = 'widget-iconBackgroundType';
export const WIDGET_ICON_BACKGROUND_TYPE_PATH = `style.numbers.${WIDGET_ICON_BACKGROUND_TYPE}`;

export const WIDGET_ICON_BACKGROUND_COLOR = 'widget-iconBackgroundColor';
export const WIDGET_ICON_BACKGROUND_COLOR_PATH = `style.colors.${WIDGET_ICON_BACKGROUND_COLOR}`;
export const WIDGET_ICON_BACKGROUND_COLOR_CLASS = 'icon-background-color';

export const WIDGET_ICON_COLOR = 'widget-iconColor';
export const WIDGET_ICON_COLOR_PATH = `style.colors.${WIDGET_ICON_COLOR}`;
export const WIDGET_ICON_COLOR_CLASS = 'icon-color';

export const WIDGET_ICON_COLOR_NO_BACKGROUND = 'widget-iconColorNoBackground';
export const WIDGET_ICON_COLOR_NO_BACKGROUND_PATH = `style.colors.${WIDGET_ICON_COLOR}`;
export const WIDGET_ICON_COLOR_NO_BACKGROUND_CLASS = 'icon-color-no-background';



// WEBPACK FOOTER //
// ./rss-feed-widget/constants/wix-params.js